export const isMobile = window.innerWidth <= 768;

/**
 * Image uploader expects to do a request, so we mock one
 */
export const dummyRequest = ({ file, onSuccess }) => {
  onSuccess("ok");
};
